import React from 'react';
import styled from 'styled-components';
import AppBar from '@material-ui/core/AppBar';

const StyledAppBar = styled(AppBar)`
  padding: 20px;
  font-size: 13px;
`;
const CardItemContainer = styled('div')`
  position: relative;
  margin: 0 0 30px;
  background: ${({ theme }) => theme.colors.light.primary};
  border: 1px solid ${({ theme }) => theme.colors.light.border};
`;
const CardContent = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 0;
  background: ${({ theme }) => theme.colors.plainWhite};
`;

interface IProps {
  title: string;
  children: any;
  className?: string;
}
export default ({ title, children, className }: IProps) => {
  return (
    <CardItemContainer className={className}>
      <StyledAppBar position="static" color="secondary">
        {title}
      </StyledAppBar>
      <CardContent className="card-content">{children}</CardContent>
    </CardItemContainer>
  );
};
